export { isAppPath, type AppHref } from './route';
